import { IComponentOptions } from 'angular';
import { ManageUsersFabCtrl } from './manage-users-fab.controller';

export const ManageUsersFabComponent: IComponentOptions = {
  bindings: {
    addNewSchoolUser: '&',
    school: '<',
  },
  controller: ManageUsersFabCtrl,
  template: require('./manage-users-fab.html'),
};
